<template>
  <div>
    <form id="formulario">
      <h2 id="title_login">Esqueci Senha</h2>
      <p id="help">Insira seu e-mail abaixo que iremos te encaminhar um e-mail para modificação da senha.</p>
      <input type="message" v-model="email" placeholder="E-mail" /> <br />
      <p id="message">{{message}}</p>
      <button type="button" name="" v-on:click="sendRequestResetPassword">Esqueci a senha</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "EsqueciSenha",
  data: () => ({
      email: '',
      message: '',
      retorno: null
  }),
  methods: {
      sendRequestResetPassword(){
          if(this.email && this.email.length > 2 && this.email.includes('@') && this.email.includes('.')){
              this.$http.post('/projects/forgot-password', {email: this.email})
                        .then(res => {
                            this.retorno = res.data;
                            this.message = 'E-mail para mudar senha enviado!';
                        }).catch(err => {
                            
                            this.message = err.error;
                        });
          } else{
            this.message = 'E-mail inválido';
          }
      }
  }
};
</script>

<style>
#formulario {
  margin-top: 40px;
}

#title_login {
  font-size: 20px;
}

#esqueci_pass_txt {
  font-size: 14px;
  margin-top: 10px;
  color: #707070;
}

#formulario input {
  width: 30%;
  border-radius: 10px;
  margin-top: 10px;
  font-size: 16px;
  border: 1px solid #e4e4e4;
  padding: 10px;
}

#message{
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
}

#help{
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
}

#formulario button {
  width: 20%;
  margin-top: 20px;
  margin-bottom: 40px;
  background-color: #8d816b;
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}
</style>
